import { AbuseType } from './types';

export const ABUSE_URL =
  process.env.GATSBY_API_ENDPOINT + '/abuse/submit-form' || '';

export const ABUSE_TYPES: Record<string, AbuseType> = {
  CopyrightDmca: {
    label: 'Copyright Infringement & DMCA Violations',
    value: 'CopyrightDmca',
    fields: {
      firstName: 1,
      lastName: 1,
      contactEmail: 1,
      companyName: 1,
      phone: 1,
      address: 1,
      city: 1,
      stateOrProvince: 1,
      country: 1,
      infringingUrls: 1,
      originalWorkDescription: 1,
      digitalSignature: 1,
      acknowledgment512f: 1,
      copyrightHolderName: 1,
    },
  },
  TrademarkInfringement: {
    label: 'Trademark Infringement',
    value: 'TrademarkInfringement',
    fields: {
      firstName: 1,
      lastName: 1,
      contactEmail: 1,
      companyName: 1,
      phone: 1,
      trademarkedWordOrSymbol: 1,
      registrationNumber: 1,
      registrationOffice: 1,
      infringingUrls: 1,
      evidenceOfAbuse: 1,
      dsaCertification: 1,
      comments: 1,
    },
  },
  CSAM: {
    label: 'Child Sexual Abuse Material (CSAM)',
    value: 'CSAM',
    fields: {
      firstName: 1,
      lastName: 1,
      contactEmail: 1,
      companyName: 1,
      phone: 1,
      country: 1,
      infringingUrls: 1,
      evidenceOfAbuse: 1,
      comments: 1,
      dsaCertification: 1,
    },
  },
  NCSEI: {
    label: 'Non-Consensual Sexually Explicit Imagery (NCSEI)',
    value: 'NCSEI',
    fields: {
      firstName: 1,
      lastName: 1,
      contactEmail: 1,
      companyName: 1,
      phone: 1,
      country: 1,
      infringingUrls: 1,
      evidenceOfAbuse: 1,
      comments: 1,
      digitalSignature: 1,
      dsaCertification: 1,
    },
  },
  ViolentThreatsAndHarassment: {
    label: 'Violent Threats and Harassment',
    value: 'ViolentThreatsAndHarassment',
    fields: {
      firstName: 1,
      lastName: 1,
      contactEmail: 1,
      companyName: 1,
      phone: 1,
      country: 1,
      infringingUrls: 1,
      evidenceOfAbuse: 1,
      comments: 1,
      dsaCertification: 1,
    },
  },
  PhishingAndMalware: {
    label: 'Phishing & Malware',
    value: 'PhishingAndMalware',
    fields: {
      firstName: 1,
      lastName: 1,
      contactEmail: 1,
      companyName: 1,
      phone: 1,
      country: 1,
      infringingUrls: 1,
      evidenceOfAbuse: 1,
      comments: 1,
      dsaCertification: 1,
    },
  },
  General: {
    label: 'General',
    value: 'General',
    fields: {
      firstName: 1,
      lastName: 1,
      contactEmail: 1,
      companyName: 1,
      phone: 1,
      country: 1,
      infringingUrls: 1,
      sourceIps: 1,
      destinationIps: 1,
      destinationPortsAndProtocols: 1,
      evidenceOfAbuse: 1,
      comments: 1,
      dsaCertification: 1,
    },
  },
  FakeNewsOrMisinformation: {
    label: 'Fake News or Misinformation',
    value: 'FakeNewsOrMisinformation',
    fields: {
      firstName: 1,
      lastName: 1,
      contactEmail: 1,
      companyName: 1,
      phone: 1,
      country: 1,
      infringingUrls: 1,
      comments: 1,
      dsaCertification: 1,
    },
  },
};
